import { ErrorBoundary, HStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';

import { ProductsManagementAvaliableItem } from '../../../../store/ProducManagement/types';

import { FixedIncomeTable } from './ProductsTable/FixedIncome';
import { FundsTable } from './ProductsTable/Funds';

interface DynamicProductsTableProps {
  selectedTabIndex: number;
  loading: boolean;
  data?: ProductsManagementAvaliableItem;
  error?: Error;
  refresher: () => void;
  onDetails: (productId: number, managerImage: string, productName: string) => void;
}
export const DynamicProductsTable = ({
  data,
  error,
  refresher,
  ...props
}: DynamicProductsTableProps) => {
  if (error) {
    return (
      <Box py={{ sm: Spacing['inline.md'] }} width="full">
        <ErrorBoundary onRefresh={refresher} />
      </Box>
    );
  }

  const renderTableByProductType = () => {
    switch (props.selectedTabIndex) {
      case 0:
        return <FundsTable data={data?.assetsFundsControl} {...props} />;
      case 1:
        return <FixedIncomeTable data={data?.assetsFixedIncomeControl} {...props} />;
      default:
        return <HStack />;
    }
  };

  return renderTableByProductType();
};
